module.exports = __webpack_public_path__ + "img/qrcode.400f1b30.jpg";